export const TASK_ACTIVE_COLUMN = [
	{
		keys: [ "taskCounter" ],
		columnHeader: "ID",
		id: "taskCounter",
		sortKey: "taskCounterNumeric",
		style: { width: 107 },
		disabled: true,
		alwaysActive: true,
	},
	{ keys: [ "task" ], columnHeader: "Title", id: "task", sortKey: "nameLowercase" },
	{
		keys: [ "category" ],
		columnHeader: "Type",
		id: "task-type",
		style: { width: 135, textAlign: "left" },
	},
	{
		keys: [ "milestoneCounter" ],
		columnHeader: "Milestone ID",
		id: "milestoneCounter",
		sortKey: "milestoneCounter",
		style: { width: 107 },
	},
	{
		keys: [ "userCategory" ],
		columnHeader: "Category",
		id: "userCategory",
		sortKey: "userCategory",
		style: { width: 135 },
	},
	{
		keys: [ "percentComplete" ],
		columnHeader: "Progress",
		id: "progress",
		style: { width: 135, textAlign: "left" },
	},
	{
		keys: [ "assignedFromName" ],
		columnHeader: "Created by",
		id: "from",
		sortKey: "assignedFrom",
		style: { width: 240 },
		active: false,
	},
	{
		keys: [ "assigneeName" ],
		columnHeader: "Assigned to",
		id: "assigned-to",
		sortKey: "assignee",
		style: { width: 240 },
	},
	{
		keys: [ "createdOn" ],
		columnHeader: "Created",
		id: "createdOn",
		sortKey: "createTime",
		style: { width: 135 },
		active: false,
	},
	{
		keys: [ "lastUpdated" ],
		columnHeader: "Last Activity",
		id: "lastUpdated",
		sortKey: "lastUpdated",
		style: { width: 135 },
		active: false,
	},
	{
		keys: [ "internalDueDate" ],
		columnHeader: "Internal Due Date",
		id: "internalDueDate",
		sortKey: "internalDueDate",
		style: { width: 110, minWidth: 110, textWrap: "auto" },
	},
	{
		keys: [ "dueOn" ],
		columnHeader: "External Due Date",
		id: "dueOn",
		sortKey: "dueDate",
		style: { width: 110, minWidth: 110, textWrap: "auto" },
	},
	{
		keys: [ "status" ],
		columnHeader: "Status",
		id: "status",
		style: { width: 100 },
	},
];

export const TASK_CATEGORIES = {
	CAYUSE_SP_AD_HOC: "CAYUSE_SP_AD_HOC",
	CAYUSE_SP_SYSTEM: "CAYUSE_SP_SYSTEM",
	CAYUSE_SP_MILESTONE: "CAYUSE_SP_MILESTONE",
};

export const TASK_CATEGORIES_FILTER_LABELS = {
	[TASK_CATEGORIES.CAYUSE_SP_AD_HOC]: "SP Adhoc",
	[TASK_CATEGORIES.CAYUSE_SP_MILESTONE]: "SP Milestone",
};

export const TASK_TYPES = {
	[TASK_CATEGORIES.CAYUSE_SP_AD_HOC]: "SP Adhoc",
	[TASK_CATEGORIES.CAYUSE_SP_SYSTEM]: "System Task",
	[TASK_CATEGORIES.CAYUSE_SP_MILESTONE]: "SP Milestone",
};

export const TASK_STATUS = {
	OPEN: "Open",
	CLOSED: "Closed",
	IN_PROGRESS: "In Progress",
	ON_HOLD: "On Hold"
};

export const TASK_STATUS_ENUM = {
	OPEN: "OPEN",
	CLOSED: "CLOSED",
	IN_PROGRESS: "IN_PROGRESS",
	ON_HOLD: "ON_HOLD"
};

export const TASK_FILTER = [
	{
		key: "status",
		label: "Status",
		options: [
			{ value: TASK_STATUS_ENUM.OPEN, label: TASK_STATUS.OPEN },
			{ value: TASK_STATUS_ENUM.IN_PROGRESS, label: TASK_STATUS.IN_PROGRESS },
			{ value: TASK_STATUS_ENUM.ON_HOLD, label: TASK_STATUS.ON_HOLD },
			{ value: TASK_STATUS_ENUM.CLOSED, label: TASK_STATUS.CLOSED },
		],
	},
	{
		key: "type",
		label: "Type",
		options: [
			{ value: TASK_CATEGORIES.CAYUSE_SP_AD_HOC, label: TASK_CATEGORIES_FILTER_LABELS.CAYUSE_SP_AD_HOC },
			{ value: TASK_CATEGORIES.CAYUSE_SP_MILESTONE, label: TASK_CATEGORIES_FILTER_LABELS.CAYUSE_SP_MILESTONE },
		],
	},
];
